import React, { useEffect, useState } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { loadVariants } from '../../Actions/Rutab/VariantFilter.action';

const VariantFilter = (props) => {
    const dispatch = useDispatch();
    const variants = useSelector((state) => state.variantFilter.variants);
    const [filteredVariants, setfilteredVariants] = useState([]);
    const [SelectedFilters, setSelectedFilters] = useState([]);

    useEffect(() => {
        dispatch(loadVariants());
    }, []);

    useEffect(() => {
        if (SelectedFilters.length === 0) {
            setfilteredVariants(variants.variants);
            return;
        }
        let vars = []
        variants.variants?.forEach((variant => {
            if (shouldRender(variant)) {
                vars.push(variant)
            }
        }))
        setfilteredVariants(vars);

    }, [SelectedFilters, variants]);

    function onSelect(selectedList, selectedItem) {
        let filterTypeIndex = SelectedFilters.findIndex(e => e.title == selectedItem.title)

        if (filterTypeIndex > -1) {
            SelectedFilters[filterTypeIndex] = { title: selectedItem.title, selectedList }
            setSelectedFilters([...SelectedFilters])
        }
        else {
            setSelectedFilters([...SelectedFilters, { title: selectedItem.title, selectedList }])
        }
    }

    function onRemove(selectedList, removedItem) {
        let index = SelectedFilters.findIndex(e => e.title == removedItem.title)

        if (selectedList.length === 0) {
            SelectedFilters.splice(index, 1)
            setSelectedFilters([...SelectedFilters])
            return
        }

        if (index > -1) {
            SelectedFilters[index] = { title: removedItem.title, selectedList }
            setSelectedFilters([...SelectedFilters])
            return
        }
    };

    function shouldRender(variant) {
        let shouldRender = true;
        SelectedFilters.forEach((filter) => {
            if (!filter.selectedList.some(sl => variant.filterValues.some(f => f.value == sl.id && f.title == sl.title))) {
                shouldRender = false;
                return;
            }
        })
        return shouldRender;
    }

    const getVariantFieldData = (variant, fieldId, i) => {
        var information = variant.variantInformation.find((item) => item.id === fieldId);
        if (information?.type == "MediaPointerImage") {
            return (
                <td key={i} className="product-variant-image-cell">
                    <img className="product-variant-image" src={information.value} />
                </td>
            );
        }

        return (
            <td key={i} dangerouslySetInnerHTML={{ __html: information?.value }} />
        );
    }


    return (
        <div className='desktop-container'>
            <div className='small-12 columns'>
                <div className="row-inner">
                    {variants.variantFilterOptions?.map((filterOption, i) =>
                        <div key={i}>
                            <Multiselect
                                placeholder={filterOption.title}
                                showCheckbox
                                options={filterOption?.options}
                                onSelect={onSelect}
                                onRemove={onRemove}
                                displayValue='name'
                                id={filterOption.title}
                            />
                        </div>
                    )}
                </div>
                <div className="row-inner">
                    <table>
                        <thead>
                            <tr>
                                {variants.variantInformationTitles?.map((title, i) =>
                                    (<td key={i}>{title.title}</td>)
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredVariants?.map((variant, i) =>
                                <tr key={i}>
                                    {variants.variantInformationTitles?.map((title, i) =>
                                        getVariantFieldData(variant, title.id, i)
                                    )}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    );
};
export default VariantFilter;
